import Vue from "vue"

import utilsApi from "@/api/utils"
import { createFetchPageAction } from "@/store/helpers/createFetchPageAction"
const initialObject = {
  _id: undefined,
  name: undefined,
  body: undefined,
  description: undefined,
  parent_collection: undefined,
  media: undefined,
  status: undefined,
  tags: undefined,
  createdAt: undefined,
  updatedAt: undefined
}
const ignoreObjectsFields = ["createdAt", "updatedAt"]
// general state for the site

const initialState = {
  product_collections: [],
  count: 0,
  page: 1,
  fetched: false,
  error: false,
  object: initialObject,
  isNew: false,
  selected: []
}

const state = Object.assign({}, initialState)

const getters = {
  product_collections: (state) => state.product_collections,
  product_collectionsIndex: (state) => (payload) => {
    const { param, parent, key } = payload || {}
    return payload
      ? param
        ? key
          ? parent
            ? state[param] && state[param][parent] && state[param][parent][key]
              ? state[param][parent][key]
              : undefined
            : state[param] && state[param][key]
            ? state[param][key]
            : undefined
          : state[param]
          ? state[param]
          : undefined
        : state
      : state
  },
  product_collectionsError: (state) => state.error,
  product_collections_Object: (state) => state.object,
  product_collections_isNew: (state) => state.isNew,
  product_collections_selected: (state) => state.selected
}
const actions = {
  async DELETE_product_collections({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.deleteObject("product-collections", object)
    if (apiResponse != null) {
      //console.log("DELETE_COLLECTIONS", apiResponse, object)
      dispatch("FETCH_PAGE_product_collections", state.page)
      return true
    } else {
      commit("PRODUCTCOLLECTIONS_ERROR")
      return false
    }
  },
  async DELETE_SELECTED_product_collections({ state, dispatch, commit }) {
    let deletions = await Promise.all(
      state.selected.map(async (current) => {
        return await dispatch("DELETE_product_collections", current)
      })
    )
    if (deletions.includes(false)) {
      return false
    } else {
      commit("SET_product_collections", {
        param: "selected",
        value: []
      })
      return true
    }
  },
  UPDATE_product_collectionsState({ commit }, payload) {
    commit("SET_product_collections", payload)
    return true
  },
  async UPDATE_product_collections({ commit, dispatch, state }, object) {
    const filtered = Object.keys(object)
      .filter((key) => !ignoreObjectsFields.includes(key))
      .reduce((obj, key) => {
        obj[key] = object[key]
        return obj
      }, {})
    let apiResponse = await utilsApi.updateObject(
      "product-collections",
      filtered
    )
    if (apiResponse != null) {
      //console.log("EN UPDATE COLLECTIONS", apiResponse, object)
      dispatch("FETCH_PAGE_product_collections", state.page)
      commit("PRODUCTCOLLECTIONS_SETTING", apiResponse)
      return true
    } else {
      commit("PRODUCTCOLLECTIONS_ERROR")
      return false
    }
  },
  async CREATE_product_collections({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.createObject("product-collections", object)
    if (apiResponse != null) {
      commit("SET_product_collections", {
        param: "object",
        value: apiResponse.collection
      })
      dispatch("FETCH_PAGE_product_collections", state.page)
      return true
    } else {
      commit("PRODUCTCOLLECTIONS_ERROR")
      return false
    }
  },
  async FETCH_product_collections({ commit }) {
    try {
      const apiResponse = await utilsApi.getAllObjects("product-collections")
      if (apiResponse != null) {
        commit("PRODUCTCOLLECTIONS_SETTING", {
          product_collections: apiResponse.items,
          count: apiResponse.total,
          page: 1
        })
        return true
      } else {
        commit("PRODUCTCOLLECTIONS_ERROR")
        return false
      }
    } catch (error) {
      console.error("Error in FETCH_product_collections:", {
        message: error.message
      })
      commit("PRODUCTCOLLECTIONS_ERROR")
      return false
    }
  },
  FETCH_PAGE_product_collections: createFetchPageAction(
    "product-collections",
    "PRODUCTCOLLECTIONS_SETTING",
    "PRODUCTCOLLECTIONS_ERROR",
    "product_collections"
  ),

  UPDATE_OBJECT_product_collections({ commit }, payload) {
    commit("SET_OBJECT_COLLECTION", payload)
    return true
  },
  CLEAN_OBJECT_product_collections({ commit }) {
    commit("SET_OBJECT_COLLECTION_INITIAL")
    return true
  },
  async CLEAN_STORE_product_collections({ commit }) {
    const initialStateKeys = Object.keys(initialState)

    await Promise.all(
      initialStateKeys.map(async (current) => {
        await commit("SET_product_collections", {
          param: current,
          value: initialState[current]
        })
        return true
      })
    )

    return true
  },
  UPDATE_SELECTED_product_collections({ commit }, payload) {
    commit("SET_SELECTED_COLLECTIONS", payload)
    return true
  }
}
const mutations = {
  PRODUCTCOLLECTIONS_SETTING: (
    state,
    { product_collections, count = undefined, page }
  ) => {
    state.count = count ?? state.product_collections.length
    state.page = page ?? state.page
    state.product_collections = product_collections
    state.fetched = true
    state.error = false
  },
  PRODUCTCOLLECTIONS_ERROR: (state) => {
    state.product_collections = null
    state.fetched = true
    state.error = false
  },
  SET_OBJECT_COLLECTION: (state, payload) => {
    Object.keys(initialObject).map((key) => {
      state.object[key] = payload[key]
    })
  },
  SET_OBJECT_COLLECTION_INITIAL: (state) => {
    state.object = { ...initialObject }
  },
  SET_SELECTED_COLLECTIONS: (state, selectedProducts) => {
    state.selected = selectedProducts
  },
  SET_product_collections: (state, payload) => {
    const { param, parent, key, value } = payload
    //console.log("SETTING FORMS STATE IN", param, value, key, parent)
    key
      ? parent
        ? state[param]
          ? state[param][parent]
            ? Vue.set(state[param][parent], key, value)
            : Vue.set(state[param], parent, {}) &&
              Vue.set(state[param][parent], key, value)
          : Vue.set(state, param, {}) &&
            Vue.set(state[param], parent, {}) &&
            Vue.set(state[param][parent], key, value)
        : state[param]
        ? Vue.set(state[param], key, value)
        : Vue.set(state, param, {}) && Vue.set(state[param], key, value)
      : Vue.set(state, param, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
